// Video Block Controller - Vanilla JS
(function() {
  'use strict';

  function initVideoBlock() {
    const videoBlocks = document.querySelectorAll('.da-video-block__video-wrapper');
    
    console.log('Found video blocks:', videoBlocks.length);
    
    videoBlocks.forEach(wrapper => {
      const video = wrapper.querySelector('.da-video-block__video');
      const playButton = wrapper.querySelector('.da-video-block__play-button');
      const muteButton = wrapper.querySelector('.da-video-block__mute-button');
      
      if (!video) {
        console.log('No video element found');
        return;
      }

      console.log('Video element found, initializing...');

      // Set initial state
      let isPlaying = false;
      let isMuted = true;
      
      // Update button icons
      function updatePlayButton() {
        if (!playButton) return;
        
        const icon = isPlaying ? `
          <svg fill="none" stroke="#333" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <rect x="6" y="4" width="4" height="16" rx="1"/>
            <rect x="14" y="4" width="4" height="16" rx="1"/>
          </svg>
        ` : `
          <svg fill="#333" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 5v14l11-7z"/>
          </svg>
        `;
        
        playButton.innerHTML = icon;
        console.log('Play button updated, isPlaying:', isPlaying);
      }
      
      function updateMuteButton() {
        if (!muteButton) return;
        
        const icon = isMuted ? `
          <svg fill="none" stroke="#333" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 5L6 9H2v6h4l5 4V5z"/>
            <line x1="23" y1="9" x2="17" y2="15"/>
            <line x1="17" y1="9" x2="23" y2="15"/>
          </svg>
        ` : `
          <svg fill="none" stroke="#333" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 5L6 9H2v6h4l5 4V5z"/>
            <path d="M15.54 8.46a5 5 0 010 7.07"/>
          </svg>
        `;
        
        muteButton.innerHTML = icon;
        console.log('Mute button updated, isMuted:', isMuted);
      }

      // Play/Pause toggle
      if (playButton) {
        playButton.addEventListener('click', () => {
          if (isPlaying) {
            video.pause();
            isPlaying = false;
          } else {
            video.play().catch(err => console.log('Play error:', err));
            isPlaying = true;
          }
          updatePlayButton();
        });
      }

      // Mute/Unmute toggle
      if (muteButton) {
        muteButton.addEventListener('click', () => {
          isMuted = !isMuted;
          video.muted = isMuted;
          updateMuteButton();
        });
      }

      // Track video state changes
      video.addEventListener('play', () => {
        isPlaying = true;
        updatePlayButton();
      });

      video.addEventListener('pause', () => {
        isPlaying = false;
        updatePlayButton();
      });

      // Intersection Observer for autoplay on scroll
      const observerOptions = {
        threshold: 0.5, // Play when 50% visible
        rootMargin: '0px'
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          console.log('Intersection:', entry.isIntersecting, 'isPlaying:', isPlaying);
          if (entry.isIntersecting && !isPlaying) {
            // Autoplay when scrolled into view
            video.play().then(() => {
              isPlaying = true;
              updatePlayButton();
              console.log('Video started playing');
            }).catch(err => {
              console.log('Autoplay prevented:', err);
            });
          }
        });
      }, observerOptions);

      observer.observe(wrapper);

      // Initialize button states immediately
      updatePlayButton();
      updateMuteButton();
      
      console.log('Video block initialized');
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoBlock);
  } else {
    initVideoBlock();
  }
})();